import { Injectable } from '@angular/core';
import { ObservableService } from '@modweb5/sharedServices/observableService/observable-service.service';
import { TConfigSystem } from '@modweb5/interfaces/modules.interface';
import { environment } from '@modweb5/environments/frontends/environment';
import { CommonService } from '@modweb5/sharedServices/commonService/common.service';
import { TLangOptions } from '@modweb5/interfaces/translation.interface';

@Injectable({
	providedIn: 'root'
})
export class ConfigApp {

	actualConfigSystem: TConfigSystem;
	defaultConfigSystem: TConfigSystem;
	localStoreName: string;

	constructor(
		private observableService: ObservableService,
		private commonService: CommonService
	) {
		this.localStoreName = `${environment.cookiePrefix}_config_system`;
	}

	// ----------------------------------------------------------------------------------------------
	init(): void {

		this.setDefaultConfigSystem();
		const lang = this.commonService.getCookie(`${environment.cookiePrefix}_lang`);
		if (lang === null) {
			this.observableService.emitLang('cs');
		} else {
			this.observableService.emitLang(lang);
		}

/*
		const langOptions: TLangOptions | null = [
			{ "lang" : "cs", "description": "Přepnutí do češtiny", "activeMessage": "Vybraný jazyk: čeština" },
			{ "lang" : "en", "description": "Switch to English",  "activeMessage": "Selected language: English" },
			{ "lang" : "de", "description": "Wechseln Sie zu Deutsch", "activeMessage": "Gewählte Sprache: Deutsch" }
		];
*/

/*
		const langOptions: TLangOptions | null = [
			{ "lang" : "cs", "description": "Přepnutí do češtiny", "activeMessage": "Vybraný jazyk: čeština" },
			{ "lang" : "en", "description": "Switch to English",  "activeMessage": "Selected language: English" }
		];
*/

		const langOptions: TLangOptions | null = [
			{ "lang" : "cs", "description": "Přepnutí do češtiny" }
		];

		this.observableService.emitLangOptions(langOptions);

		let pConfigSystem: TConfigSystem;
		if (localStorage.getItem(this.localStoreName) !== null) {
			pConfigSystem =  JSON.parse(localStorage.getItem(this.localStoreName));
		} else {
			pConfigSystem = this.defaultConfigSystem;
			localStorage.setItem(this.localStoreName, JSON.stringify(pConfigSystem));
		}
		// Konfigurace emituje nastavení konfigurace do observableService, která má nastavení observable
		// na konfiguraci. Konfiguraci tak má k dispozici každý subscriber, který 
		this.observableService.emitActualConfigSystem(pConfigSystem);
	}

	//-----------------------------------------------------------------------------------------------
	private setDefaultConfigSystem(): void {
	// Zde je uložen defaultní konfigurace a současně i defaultní verze konfugurace
	// Až něco do konfigurace přibude, zvýší se verze a pokud systém zjistí, že má v local storage 
	// nižší verzi, vezme si nastavení nově přidané položky z defaultní konfigurace.

		this.defaultConfigSystem = {
			version: 1, 
			modules: {
				rememberSentenceId: true,
				confirmCloseModule: true
			}
		}
		this.observableService.emitDefaultConfigSystem(this.defaultConfigSystem);
	}


}
